module.exports = __webpack_public_path__ + "media/images/lb/169-0bc0fc6c9684ed86383fe2d0513524b3.svg";